import { MarkdownEditor, ViewMode } from '@efdigital/ll-addon-codemirror';
import type { QuizResponse } from '@efdigital/ll-addon-data';
import { SidebarAll } from '@efdigital/ll-admin-v2/lib/markdown-toolbar';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    /**
     * The label to display for this response editor
     */
    label: string;
    /**
     * The response object to edit
     */
    response: QuizResponse;
  };
}

export default class EditResponse extends Component<Signature> {
  setMarkdown = (markdown: string) => {
    this.args.response.markdown = markdown;
  };

  setTitle = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.args.response.title = target.value;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="mb-4">
        <div class="mb-3">
          <label for="{{uniqueId}}-title" class="form-label">Heading</label>
          <input
            type="text"
            id="{{uniqueId}}-title"
            class="form-control"
            value={{@response.title}}
            placeholder="Response heading"
            {{on "input" this.setTitle}}
          />
        </div>

        <div class="mb-3">
          <label for="{{uniqueId}}-markdown" class="form-label">Body</label>
          <MarkdownEditor
            @markdown={{@response.markdown}}
            @toolbar={{SidebarAll}}
            @mode={{ViewMode.EditorOnly}}
            @onUpdate={{this.setMarkdown}}
          >
            <:preview as |markdown|>
              <pre>{{markdown}}</pre>
            </:preview>
          </MarkdownEditor>
        </div>
      </div>
    {{/let}}
  </template>
}
